import { Skeleton } from '@modulor/react';
import React from 'react';

import style from './SkeletonDefaultInit.module.scss';

const SkeletonNetwork = () => (
  <Skeleton width="100%" height={40} borderRadius={12} padding={8}>
    <div className={style.item}>
      <div className={style.img} />
      <div className={style.description} />
    </div>
  </Skeleton>
);

export default SkeletonNetwork;
